export const INSERT_THUMB_TYPE_BLANK = 'INSERT_THUMB_TYPE_BLANK';
export const INSERT_THUMB_TYPE_TURBO_URETHANE_THUMB_SLUG =
  'INSERT_THUMB_TYPE_TURBO_URETHANE_THUMB_SLUG';
export const INSERT_THUMB_TYPE_TURBO_XCEL_SOLID =
  'INSERT_THUMB_TYPE_TURBO_XCEL_SOLID';
export const INSERT_THUMB_TYPE_TURBO_XCEL_ROUND =
  'INSERT_THUMB_TYPE_TURBO_XCEL_ROUND';
export const INSERT_THUMB_TYPE_TURBO_XCEL_OVAL =
  'INSERT_THUMB_TYPE_TURBO_XCEL_OVAL';
export const INSERT_THUMB_TYPE_ULTIMATE_URETHANE_SLUG =
  'INSERT_THUMB_TYPE_ULTIMATE_URETHANE_SLUG';
export const INSERT_THUMB_TYPE_ULTIMATE_THUMB =
  'INSERT_THUMB_TYPE_ULTIMATE_THUMB';
export const INSERT_THUMB_TYPE_TURBO_SWITCH_GRIP =
  'INSERT_THUMB_TYPE_TURBO_SWITCH_GRIP';
export const INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL =
  'INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL';
export const INSERT_THUMB_TYPE_VISE_PRO_V2 = 'INSERT_THUMB_TYPE_VISE_PRO_V2';
export const INSERT_THUMB_TYPE_VISE_IT = 'INSERT_THUMB_TYPE_VISE_IT';
export const INSERT_THUMB_TYPE_VISE_EASY_URETHANE_SLUG =
  'INSERT_THUMB_TYPE_VISE_EASY_URETHANE_SLUG';
export const INSERT_THUMB_TYPE_VISE_VINYL_SLUG =
  'INSERT_THUMB_TYPE_VISE_VINYL_SLUG';
